<script>
    import { onMount } from "svelte";

    import EFTsDefaultTable from "./EFTsDefaultTable.svelte";
    import EFTsReconcile from "./EFTsReconcile.svelte";

    export let params = {};

    let isShowReconcileTable = false,
        selectedReconciliationEftID = Number(0);

    onMount(() => {
        checkIsShowReconcileTable();
    });

    const checkIsShowReconcileTable = () => {
        if (!params.query) return;

        const arr = params.query.split("&");

        if (arr.some((attr) => attr.includes("selectedReconciliationEftID="))) {
            selectedReconciliationEftID = Number(
                arr
                    .find((attr) =>
                        attr.includes("selectedReconciliationEftID=")
                    )
                    .replace("selectedReconciliationEftID=", "")
            );
            isShowReconcileTable = true;
        }
    };

    const toggleShowEFTsTable = (eftID) => {
        if (eftID) selectedReconciliationEftID = Number(eftID);
        else selectedReconciliationEftID = Number(0);

        isShowReconcileTable = !isShowReconcileTable;
    };
</script>

<div class="flex flex-col flex-1 gap-y-4">
    {#if isShowReconcileTable}
        <EFTsReconcile
            {params}
            {toggleShowEFTsTable}
            {selectedReconciliationEftID}
        />
    {:else}
        <EFTsDefaultTable {params} {toggleShowEFTsTable} />
    {/if}
</div>
